var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIconWhitelabel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "body_1",
    width: 83,
    height: 37,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.3738739 0 0 0.37 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 1 0 0)",
    d: "M38.6578 44.5179L28.828 44.5179L16.1626 29.8677L8.22306 29.8677L8.22306 44.4234L0 44.4234L0 0.850647C 6.89981 0.850647 13.7996 0.945165 20.7939 0.945165C 31.0019 0.945165 36.4839 7.75046 36.4839 15.3119C 36.4839 21.2665 33.7429 27.3157 25.4253 29.017L25.4253 29.017L38.6578 43.9508L38.6578 44.5179zM8.22306 8.5066L8.22306 22.4953L20.7939 22.4953C 25.9924 22.4953 28.2609 18.9981 28.2609 15.5009C 28.2609 12.0038 25.8979 8.5066 20.7939 8.5066L20.7939 8.5066L8.22306 8.5066z",
    stroke: "none",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 1 0 0)",
    d: "M87.1456 22.9679C 87.051 34.2155 80.1512 45.5577 64.7448 45.5577C 49.3384 45.5577 42.3441 34.4991 42.3441 22.9679C 42.3441 11.5312 49.7165 0 64.8393 0C 79.8677 0 87.3346 11.5312 87.1456 22.9679zM50.4726 23.1569C 50.6616 30.3403 54.5369 37.9962 64.8393 37.9962C 75.1418 37.9962 79.017 30.2457 79.1115 23.0624C 79.2061 15.69 75.1418 7.46692 64.8393 7.46692C 54.5369 7.46692 50.2836 15.7845 50.4726 23.1569z",
    stroke: "none",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 1 0 0)",
    d: "M138.374 22.9679C 138.28 34.2155 131.38 45.5577 115.974 45.5577C 100.662 45.4631 93.5728 34.4991 93.5728 22.9679C 93.5728 11.5312 100.945 0 115.974 0C 131.002 0 138.469 11.5312 138.374 22.9679zM101.701 23.1569C 101.89 30.3403 105.766 37.9962 116.068 37.9962C 126.371 37.9962 130.246 30.2457 130.34 23.0624C 130.435 15.69 126.371 7.46692 116.068 7.46692C 105.766 7.46692 101.512 15.7845 101.701 23.1569z",
    stroke: "none",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 1 0 0)",
    d: "M184.972 12.8545L170.794 31.758L169.187 31.758L155.293 12.7599L155.293 44.518L147.07 44.518L147.07 0.94519L156.522 0.94519L170.132 19.6597L183.743 0.94519L193.195 0.94519L193.195 44.518L184.972 44.518L184.972 12.8545z",
    stroke: "none",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 1 0 0)",
    d: "M9.16824 73.8185L9.16824 64.5558L16.7297 64.5558L16.7297 73.8185L25.9924 73.8185L25.9924 80.7184L16.7297 80.7184L16.7297 90.0756L9.16824 90.0756L9.16824 80.7184L0 80.7184L0 73.8185L9.16824 73.8185z",
    stroke: "none",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 1 0 0)",
    d: "M72.6843 67.9584C 72.6843 71.361 71.0775 74.5747 67.0133 76.3705C 72.1172 77.8828 74.0076 83.3648 74.0076 86.1058C 74.0076 95.8412 66.7297 98.9603 57.656 98.9603C 50.7562 98.9603 43.8564 98.9603 36.9565 98.9603L36.9565 98.9603L36.9565 55.3875C 43.8564 55.3875 50.7562 55.3875 57.656 55.3875C 66.2571 55.3875 72.6843 59.1682 72.6843 67.9584zM45.0851 72.8733L57.656 72.8733C 62.8545 72.8733 64.5558 70.6994 64.5558 68.242C 64.5558 66.2571 62.949 62.8544 57.656 62.8544L57.656 62.8544L45.0851 62.8544L45.0851 72.8733zM45.0851 91.3043L57.656 91.3043C 61.0586 91.3043 65.7845 90.1701 65.7845 86.1058C 65.7845 82.1361 60.9641 80.1512 57.656 80.1512L57.656 80.1512L45.0851 80.1512L45.0851 91.3043z",
    stroke: "none",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 1 0 0)",
    d: "M125.142 77.4102C 125.047 88.6578 118.147 100 102.741 100C 87.3346 100 80.3403 88.9414 80.3403 77.5047C 80.3403 66.0681 87.7127 54.5369 102.741 54.5369C 117.769 54.4423 125.331 65.9735 125.142 77.4102zM88.4688 77.5992C 88.6579 84.7826 92.5331 92.4386 102.836 92.4386C 113.138 92.4386 117.013 84.6881 117.108 77.5047C 117.202 70.1323 113.138 61.9093 102.836 61.9093C 92.5331 61.9093 88.2798 70.2268 88.4688 77.5992z",
    stroke: "none",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 1 0 0)",
    d: "M176.371 77.4102C 176.276 88.6578 169.376 100 153.97 100C 138.658 100 131.569 88.9414 131.569 77.5047C 131.569 66.0681 138.941 54.5369 153.97 54.5369C 168.998 54.4423 176.465 65.9735 176.371 77.4102zM139.698 77.5992C 139.887 84.7826 143.762 92.4386 154.064 92.4386C 164.367 92.4386 168.242 84.6881 168.336 77.5047C 168.431 70.1323 164.367 61.9093 154.064 61.9093C 143.762 61.9093 139.509 70.2268 139.698 77.5992z",
    stroke: "none",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 1 0 0)",
    d: "M219.943 55.5765L200.567 76.465L221.55 98.4877L221.55 98.9603L211.437 98.9603L193.195 79.6786L193.195 98.9603L184.972 98.9603L184.972 55.3875L193.195 55.3875L193.195 73.8185L209.735 55.3875L219.943 55.3875L219.943 55.5765z",
    stroke: "none",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconWhitelabel);
export default __webpack_public_path__ + "static/media/logo-icon_whitelabel.e387e481abea76bd9896504a04b3bd5d.svg";
export { ForwardRef as ReactComponent };